var render = function render(){var _vm=this,_c=_vm._self._c;return (Object.keys(_vm.$slots).length)?_c('div',{staticClass:"breadcrumbs",class:{ tiny: _vm.tiny }},_vm._l((Object.keys(_vm.$slots)),function(name,index){return _c('div',{staticClass:"item"},[(index)?_c('icon',{staticClass:"margin-right hidden-xs",attrs:{"name":"arrow-right-gray"}}):_vm._e(),(_vm.$slots[name])?_vm._t(name):_vm._e()],2)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }